import React from 'react';
import { Stack } from '@mui/material';
import { IValueList } from './interfaces';

export const ValueList: React.FC<IValueList> = ({
  children,
  columns = 1,
}): JSX.Element => {
  return (
    <Stack
      flexWrap="wrap"
      direction="row"
      rowGap="15px"
      sx={{
        '& > *': {
          flexBasis: `${100 / columns}%`,
          boxSizing: 'border-box',
        },
      }}
    >
      {children}
    </Stack>
  );
};
